import { render, staticRenderFns } from "./TextControl.vue?vue&type=template&id=5f2530cb&scoped=true&"
import script from "./TextControl.vue?vue&type=script&lang=js&"
export * from "./TextControl.vue?vue&type=script&lang=js&"
import style0 from "./TextControl.vue?vue&type=style&index=0&id=5f2530cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2530cb",
  null
  
)

export default component.exports